var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "section" },
    [
      _c(
        "b-field",
        { attrs: { label: _vm.$t("pages.customer_forecast.customer") } },
        [
          _c("b-autocomplete", {
            attrs: {
              data: _vm.filteredCustomer,
              "open-on-focus": "",
              field: "displayName",
              icon: "magnifying-glass",
            },
            on: { select: _vm.selectCustomer },
            model: {
              value: _vm.selectedCustomerString,
              callback: function ($$v) {
                _vm.selectedCustomerString = $$v
              },
              expression: "selectedCustomerString",
            },
          }),
        ],
        1
      ),
      _c(
        "b-field",
        { attrs: { label: "Plant", grouped: "" } },
        [
          _c("b-autocomplete", {
            attrs: {
              expanded: "",
              data: _vm.filteredPlants,
              "open-on-focus": "",
              field: "id",
              placeholder: "plantId",
              disabled: _vm.isEditing,
            },
            on: { typing: _vm.getFilteredPlants },
            model: {
              value: _vm.selectedPlant,
              callback: function ($$v) {
                _vm.selectedPlant = $$v
              },
              expression: "selectedPlant",
            },
          }),
        ],
        1
      ),
      _c(
        "b-field",
        { attrs: { label: "Select a month" } },
        [
          _c("b-datepicker", {
            attrs: {
              type: "month",
              placeholder: "Click to select...",
              icon: "calendar",
              "trap-focus": "",
            },
            model: {
              value: _vm.selectedMonth,
              callback: function ($$v) {
                _vm.selectedMonth = $$v
              },
              expression: "selectedMonth",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "buttons level" },
        [
          _c(
            "div",
            { staticClass: "level-left" },
            [
              _c(
                "b-button",
                {
                  attrs: { type: "is-info", "icon-left": "magnifying-glass" },
                  on: { click: _vm.search },
                },
                [_vm._v(" Search ")]
              ),
              _c(
                "b-button",
                {
                  attrs: { "icon-left": "xmark" },
                  on: { click: _vm.clearFilter },
                },
                [_vm._v(" Clear ")]
              ),
              _c(
                "b-button",
                {
                  attrs: {
                    loading: _vm.loading,
                    "icon-left": "sync",
                    disabled: _vm.loading,
                  },
                  on: { click: _vm.refresh },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "pages.pickup_management.pickup_management.refresh"
                        )
                      ) +
                      " "
                  ),
                ]
              ),
              _c(
                "b-button",
                {
                  attrs: { "icon-left": "arrow-up-from-bracket" },
                  on: { click: _vm.download },
                },
                [_vm._v(" Export ")]
              ),
            ],
            1
          ),
          _c(
            "b-button",
            {
              staticClass: "level-right",
              attrs: {
                type: "is-primary",
                "icon-left": "plus",
                disabled: !_vm.selectedCustomerString,
              },
              on: {
                click: function ($event) {
                  _vm.addForecast = true
                },
              },
            },
            [_vm._v(" Add forecast ")]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column is-full" },
          [
            _c("ag-grid-vue", {
              staticClass: "ag-theme-balham",
              staticStyle: { width: "100%", height: "600px" },
              attrs: {
                "row-data": _vm.forecast,
                pagination: true,
                "pagination-auto-page-size": true,
                "multi-sort-key": "ctrl",
                modules: _vm.modules,
                "row-selection": "multiple",
                "grid-options": _vm.gridOptions,
                "get-context-menu-items": _vm.getContextMenuItems,
                "overlay-no-rows-template": _vm.overlayNoRowsTemplate,
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.addForecast,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.addForecast = $event
            },
          },
        },
        [
          _c("ForecastForm", {
            attrs: {
              plants: _vm.plants,
              customer: _vm.selectedCustomer.id,
              "cur-forecasts": _vm.curForcasts,
            },
            on: { "on-close": _vm.close },
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isEditing,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isEditing = $event
            },
          },
        },
        [
          _c("ForecastForm", {
            attrs: {
              customer: _vm.editForm.customer,
              plants: _vm.plants,
              "edit-form": _vm.editForm,
              "is-editing": _vm.isEditing,
            },
            on: { "on-close": _vm.close },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }